export const fetchConstants = {
    START: 'FETCH_START',
    CREATE: 'FETCH_CREATE',
    CREATE_END: 'FETCH_CREATE_END',
    SUCCESS: 'FETCH_SUCCESS',
    ERROR: 'FETCH_ERROR'
};
